import { render, staticRenderFns } from "./InactiveAssetsCatalog.vue?vue&type=template&id=167adb0a"
import script from "./InactiveAssetsCatalog.vue?vue&type=script&lang=js"
export * from "./InactiveAssetsCatalog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports